import React from 'react';
import {
  Box,
  Collapse,
  IconButton,
  Typography,
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import mainColors from '../../../themes/main-colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      border: `2px solid ${mainColors.lightGreen}`,
      borderRadius: 8,
      overflow: 'hidden',
      marginTop: theme.spacing(4),
    },
    header: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(2),
    },
    title: {
      fontSize: 16,
      fontWeight: 'bold',
    },
    left: {
      display: 'flex',
      alignItems: 'center',
    },
    iconCircle: {
      width: 32,
      height: 32,
      borderRadius: '50%',
      backgroundColor: mainColors.lightGreen,
      color: mainColors.white,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: theme.spacing(2),
    },
    content: {
      padding: theme.spacing(3),
      borderTop: `1px solid ${mainColors.disableColor}`,
      backgroundColor: 'transparent',
    },
  }),
);

interface Props {
  title: string;
  subtitle?: string;
  expanded: boolean;
  setExpanded: (s: boolean) => void;
  children: React.ReactNode;
}

const CollapsiblePanel: React.FC<Props> = ({
  title,
  subtitle,
  expanded,
  setExpanded,
  children,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.header} onClick={() => setExpanded(!expanded)}>
        <div className={classes.left}>
          <div className={classes.iconCircle}>
            <AddIcon fontSize="small" css={{ width: '2em' }} />
          </div>

          <div>
            <Typography variant="h4" className={classes.title}>
              {title}
            </Typography>

            {subtitle && (
              <Typography
                color="textSecondary"
                variant="body2"
                css={{ marginTop: 8 }}
              >
                {subtitle}
              </Typography>
            )}
          </div>
        </div>

        <IconButton size="small">
          <ExpandMoreIcon
            style={{
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: '0.2s',
            }}
          />
        </IconButton>
      </Box>

      <Collapse in={expanded}>
        <Box className={classes.content}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default CollapsiblePanel;
